import type { CloudpackConfig } from './CloudpackConfig.js';
import type { ModuleType } from './ModuleType.js';

export interface BundleContext {
  config: CloudpackConfig;

  /**
   * Detected module type of the entry files. This will be 'cjs' or 'amd' if any entry file was
   * detected as that type, or 'esm' is the default.
   */
  moduleType: ModuleType;

  /**
   * True if the package requires transpilation (usually with SWC) before bundling. One or more of:
   * - Is internal
   * - Has entry files that are TS or JSX
   * - Has relay capability enabled
   *
   * Note that the entry files calculation does *not* parse the files to check for JSX syntax
   * in files without a specific extension. It also only accounts for *entry files* (so things
   * like `index.js` which imports `./foo.jsx` wouldn't be detected).
   *
   * Also note this is not used by ori as of writing (it handles this internally).
   */
  requiresTranspile: boolean;
}
